<template>
  <v-textarea
    :label="label"
    @input="$emit('input', $event)"
    @click:append="$emit('clickappend')"
    v-bind="$attrs"
  ></v-textarea>
</template>

<script>
export default {
  name: 'Textarea',
  props: {
    label: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>
.input-number input[type='number'] {
  -moz-appearance: textfield;
}
.input-number input::-webkit-outer-spin-button,
.input-number input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>